<!--
 * @Author: gang.liu
 * @Date: 2021-06-28 16:13:36
 * @LastEditTime: 2021-06-30 13:30:04
 * @LastEditors: gang.liu
 * @Description: Login 登录页
 * @api-property:
 * @api-event:
 * @api-method:
-->
<template>
  <div
    class="gy-login"
    :style="{ backgroundImage: 'url(' + require('@/assets/bg.jpg') + ')' }"
  >
    <div class="gy-login-box" style="position: relative;">
      <i class="el-icon-circle-close" style="position: absolute;right: -48px;top:-20px;color:#C0C4CC;font-size: 40px;z-index: 999" @click="$router.push({path:'/'})"></i>
      <div class="gy-login-title">
        <div class="logo">
          <img :src="require('@/assets/flogo.jpg')" alt="logo" />
          <span class="line">|</span>
          <span v-if="!showQrcodeLogin">用户密码登录</span>
          <span v-else style="padding-right: 30px;">扫码登录</span>
        </div>
        <div class="qrcode" v-if="!showQrcodeLogin">
          <img :src="require('@/assets/qrcode.png')">
          <div class="qrcodeDiv" @click="showQrcodeLogin = true"></div>
        </div>

        <div class="qrcode" v-else>
          <i class="iconfont icon-user"></i>
          <div class="qrcodeDiv" @click="showQrcodeLogin = false"></div>
        </div>
      </div>

      <div class="gy-login-from" style="padding-top:40px" v-show="!showQrcodeLogin">
        <input
          class="gy-login-input"
          placeholder="手机/邮箱/用户名"
          v-model="mobile"
        />
        <input
          type="password"
          class="gy-login-input"
          placeholder="密码"
          v-model="password"
          style="margin-top:20px"
        />
        <button class="gy-login-button" @click="loginClick" style="margin-top:80px">登录</button>
        <div class="gy-login-forgot-register" style="margin-top:30px">
          <router-link to="/retrievePassword"><span>忘记密码</span></router-link>
          <router-link to="/register"><span>立即注册</span></router-link>
        </div>
      </div>

      <div class="qrcodeLogin" v-show='showQrcodeLogin'>
        <div class="qrcodeLogin_con" id='qrcodeLogin_con'>

        </div>
      </div>
    </div>

    <div>

    </div>


  </div>
</template>
<script>
import { registerService } from "@/api";
import { mapActions } from 'vuex';
export default {
  //组件名字
  name: "Login",
  //组件参数
  props: {},
  //组件状态数据值
  data() {
    return {
      mobile: "",
      password: "",
      showQrcodeLogin: false
    };
  },
  //计算属性
  computed: {},
  //方法
  methods: {
    ...mapActions("user", ["setToken", "getUserInfo"]),
    loginClick() {
      if (!this.mobile || !this.password) {
        this.$message({
          message: "请填写正确的手机号和密码！",
          type: "error",
          duration: 1000,
        });
        return;
      }
      registerService
        .login({
          mobile: this.mobile,
          password: this.password,
        })
        .then(async (res) => {
          if (res.code == 0) {
            await this.setToken(res.data.token);

            await this.getUserInfo();
            this.$router.push({
              path: "/",
            });
          } else {
            this.$message({
              message: res.msg,
              type: "error",
              duration: 1000,
            });
          }

        });
    },
    retrievePassword(){
      this.$router.push({
        path:'/retrievePassword'
      })
    },
    wechatLogin(code) {
      let data = {
        code,
      }
      registerService.wechatLogin(data).then(async res=>{
        console.log(res,'weixin login')
        if(res.code==0){
            await this.setToken(res.data.token);

            await this.getUserInfo();
            this.$router.push({
              path:'/'
            })
          }else{
            this.$message.error(res.msg);
          }
      })
    },
    getWwLoginId(value) {
      switch(value) {
        case 'test': return {"appid": "ww104023cec3996a64", "agentid" : "1000004",};
        case 'pre': return {"appid": "ww47f3957813539f80", "agentid" : "1000003",};
        case 'prod': return {"appid": "ww4d6a0d128b64fab5", "agentid" : "1000005",};
        default : return {}
      }
    }
  },
  //监听
  watch: {
    showQrcodeLogin() {
      if(this.showQrcodeLogin) {
        this.$nextTick(()=>{
          window.WwLogin({
            "id" : "qrcodeLogin_con",
            ...this.getWwLoginId(window._GLOBAL_.DEPLOY_MODEL),
            "redirect_uri" : window._GLOBAL_.OFFICIAL_WEB_URL + 'login',
          });
        })
      }
    }
  },
  /*一下是生命周期钩子，没用的钩子请自行删除 */
  //在实例初始化之后，组件属性计算之前，如data属性等
  beforeCreate() {},
  //组件实例创建完成，属性已绑定，但DOM还未生成，el属性还不存在
  created() {
    if(this.$route.query && this.$route.query.code) {
      this.wechatLogin(this.$route.query.code);
    }
  },
  //在挂载开始之前被调用：相关的 render 函数首次被调用。
  beforeMount() {},
  //el 被新创建的 vm.el 替换，并挂载到实例上去之后调用该钩子。
  mounted() {},
  //数据更新时调用，发生在虚拟 DOM 重新渲染和打补丁之前。
  //你可以在这个钩子中进一步地更改状态，这不会触发附加的重渲染过程。
  beforeUpdate() {},
  //由于数据更改导致的虚拟 DOM 重新渲染和打补丁，在这之后会调用该钩子。
  //当这个钩子被调用时，组件 DOM 已经更新，所以你现在可以执行依赖于 DOM 的操作。
  updated() {},
  //局部注册的组件
  components: {},
};
</script>

<style lang="less" scoped>
.gy-login {
  min-height: 400px;
  height: calc(100vh - 160px);
  display: flex;
  justify-content: flex-end;
  background-repeat: no-repeat;
  background-position: center center;
  background-attachment: fixed;
  background-size: cover;
  &-box {
    margin: auto;
    width: 400px;
    height: 480px;
    border: 2px solid #f4f2f3;
    background-color: white;
    align-self: center;
  }
  &-title {
    display: flex;
    justify-content: space-between;

    img {
      width: 200px;
      align-self: center;
    }
    span.line {
      margin-right: 5px;
      color: #34b4b3;
    }
    span {
      padding-top: 10px;
    }
  }
  &-from {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: center;
  }
  &-input {
    box-sizing: border-box;
    width: 90%;
    line-height: 1.8;
    font-size: 20px;
    padding: 0 20px;
    border: 2px solid #cfcfcf;
    outline: none;
    margin: 10px;
  }

  &-button {
    margin: 40px 10px 10px 10px;
    width: 360px;
    font-size: 20px;
    padding: 5px 0;
    color: white;
    background-color: #35a8a4;
    border: none;
    outline: none;
    cursor: pointer;
  }
  &-forgot-register {
    width: 100%;
    margin: 0 20px;
    display: flex;
    justify-content: space-between;
  }
  .logo {
    display: flex;
    width: 0px;
    padding-top: 20px;
    flex: 1;
    justify-content: center;
  }
  .qrcode {
    position: relative;
    background-color: #35a8a4;
    width: 70px;
    height: 70px;
    text-align: right;
    img {
      width: 70px;
      height: 70px;
    }
    .qrcodeDiv {
      width: 0px;
      height: 0px;
      border: 35px solid #fff;
      border-top-color: transparent;
      border-right-color: transparent;
      cursor: pointer;
      position: absolute;
      top: 0px;
      right: 0px;
    }
    .iconfont {
      font-size: 26px;
      margin-right: 10px;
      margin-top: 10px;
      color: #fff;
    }
  }
  .qrcodeLogin_con {
    width: 300px;
    // height: 200px;
    margin: 0 auto;
    // padding: 20px 0px;
    box-sizing: content-box;
  }
}
</style>
